export const countryAbbreviations: { [key: string]: string } = {
  AFGHANISTAN: "AFG",
  ALBANIA: "ALB",
  ALGERIA: "DZA",
  ANDORRA: "AND",
  ANGOLA: "AGO",
  "ANTIGUA AND BARBUDA": "ATG",
  ARGENTINA: "ARG",
  ARMENIA: "ARM",
  AUSTRALIA: "AUS",
  AUSTRIA: "AUT",
  AZERBAIJAN: "AZE",
  BAHAMAS: "BHS",
  BAHRAIN: "BHR",
  BANGLADESH: "BGD",
  BARBADOS: "BRB",
  BELARUS: "BLR",
  BELGIUM: "BEL",
  BELIZE: "BLZ",
  BENIN: "BEN",
  BHUTAN: "BTN",
  BOLIVIA: "BOL",
  "BOSNIA AND HERZEGOVINA": "BIH",
  BOTSWANA: "BWA",
  BRAZIL: "BRA",
  BRUNEI: "BRN",
  BULGARIA: "BGR",
  "BURKINA FASO": "BFA",
  BURUNDI: "BDI",
  "CABO VERDE": "CPV",
  CAMBODIA: "KHM",
  CAMEROON: "CMR",
  CANADA: "CAN",
  "CENTRAL AFRICAN REPUBLIC": "CAF",
  CHAD: "TCD",
  CHILE: "CHL",
  CHINA: "CHN",
  COLOMBIA: "COL",
  COMOROS: "COM",
  CONGO: "COG",
  "COSTA RICA": "CRI",
  CROATIA: "HRV",
  CUBA: "CUB",
  CYPRUS: "CYP",
  "CZECH REPUBLIC": "CZE",
  "DEMOCRATIC REPUBLIC OF THE CONGO": "COD",
  DENMARK: "DNK",
  DJIBOUTI: "DJI",
  DOMINICA: "DMA",
  "DOMINICAN REPUBLIC": "DOM",
  "EAST TIMOR": "TLS",
  ECUADOR: "ECU",
  EGYPT: "EGY",
  "EL SALVADOR": "SLV",
  "EQUATORIAL GUINEA": "GNQ",
  ERITREA: "ERI",
  ESTONIA: "EST",
  ESWATINI: "SWZ",
  ETHIOPIA: "ETH",
  FIJI: "FJI",
  FINLAND: "FIN",
  FRANCE: "FRA",
  GABON: "GAB",
  GAMBIA: "GMB",
  GEORGIA: "GEO",
  GERMANY: "DEU",
  GHANA: "GHA",
  GREECE: "GRC",
  GRENADA: "GRD",
  GUATEMALA: "GTM",
  GUINEA: "GIN",
  "GUINEA-BISSAU": "GNB",
  GUYANA: "GUY",
  HAITI: "HTI",
  HONDURAS: "HND",
  HUNGARY: "HUN",
  ICELAND: "ISL",
  INDIA: "IND",
  INDONESIA: "IDN",
  IRAN: "IRN",
  IRAQ: "IRQ",
  IRELAND: "IRL",
  ISRAEL: "ISR",
  ITALY: "ITA",
  "IVORY COAST": "CIV",
  JAMAICA: "JAM",
  JAPAN: "JPN",
  JORDAN: "JOR",
  KAZAKHSTAN: "KAZ",
  KENYA: "KEN",
  KIRIBATI: "KIR",
  KUWAIT: "KWT",
  KYRGYZSTAN: "KGZ",
  LAOS: "LAO",
  LATVIA: "LVA",
  LEBANON: "LBN",
  LESOTHO: "LSO",
  LIBERIA: "LBR",
  LIBYA: "LBY",
  LIECHTENSTEIN: "LIE",
  LITHUANIA: "LTU",
  LUXEMBOURG: "LUX",
  MADAGASCAR: "MDG",
  MALAWI: "MWI",
  MALAYSIA: "MYS",
  MALDIVES: "MDV",
  MALI: "MLI",
  MALTA: "MLT",
  "MARSHALL ISLANDS": "MHL",
  MAURITANIA: "MRT",
  MAURITIUS: "MUS",
  MEXICO: "MEX",
  MICRONESIA: "FSM",
  MOLDOVA: "MDA",
  MONACO: "MCO",
  MONGOLIA: "MNG",
  MONTENEGRO: "MNE",
  MOROCCO: "MAR",
  MOZAMBIQUE: "MOZ",
  MYANMAR: "MMR",
  NAMIBIA: "NAM",
  NAURU: "NRU",
  NEPAL: "NPL",
  NETHERLANDS: "NLD",
  "NEW ZEALAND": "NZL",
  NICARAGUA: "NIC",
  NIGER: "NER",
  NIGERIA: "NGA",
  "NORTH KOREA": "PRK",
  "NORTH MACEDONIA": "MKD",
  NORWAY: "NOR",
  OMAN: "OMN",
  PAKISTAN: "PAK",
  PALAU: "PLW",
  PALESTINE: "PSE",
  PANAMA: "PAN",
  "PAPUA NEW GUINEA": "PNG",
  PARAGUAY: "PRY",
  PERU: "PER",
  PHILIPPINES: "PHL",
  POLAND: "POL",
  PORTUGAL: "PRT",
  QATAR: "QAT",
  ROMANIA: "ROU",
  RUSSIA: "RUS",
  RWANDA: "RWA",
  "SAINT KITTS AND NEVIS": "KNA",
  "SAINT LUCIA": "LCA",
  "SAINT VINCENT AND THE GRENADINES": "VCT",
  SAMOA: "WSM",
  "SAN MARINO": "SMR",
  "SAO TOME AND PRINCIPE": "STP",
  "SAUDI ARABIA": "SAU",
  SENEGAL: "SEN",
  SERBIA: "SRB",
  SEYCHELLES: "SYC",
  "SIERRA LEONE": "SLE",
  SINGAPORE: "SGP",
  SLOVAKIA: "SVK",
  SLOVENIA: "SVN",
  "SOLOMON ISLANDS": "SLB",
  SOMALIA: "SOM",
  "SOUTH AFRICA": "ZAF",
  "SOUTH KOREA": "KOR",
  "SOUTH SUDAN": "SSD",
  SPAIN: "ESP",
  "SRI LANKA": "LKA",
  SUDAN: "SDN",
  SURINAME: "SUR",
  SWEDEN: "SWE",
  SWITZERLAND: "CHE",
  SYRIA: "SYR",
  TAIWAN: "TWN",
  TAJIKISTAN: "TJK",
  TANZANIA: "TZA",
  THAILAND: "THA",
  TOGO: "TGO",
  TONGA: "TON",
  "TRINIDAD AND TOBAGO": "TTO",
  TUNISIA: "TUN",
  TURKEY: "TUR",
  TURKMENISTAN: "TKM",
  TUVALU: "TUV",
  UGANDA: "UGA",
  UKRAINE: "UKR",
  "UNITED ARAB EMIRATES": "ARE",
  "UNITED KINGDOM": "GBR",
  "UNITED STATES": "USA",
  URUGUAY: "URY",
  UZBEKISTAN: "UZB",
  VANUATU: "VUT",
  "VATICAN CITY": "VAT",
  VENEZUELA: "VEN",
  VIETNAM: "VNM",
  YEMEN: "YEM",
  ZAMBIA: "ZMB",
  ZIMBABWE: "ZWE",
}

export const countryNameToAbbrev = (name: string): string => {
  const upperName = name.toUpperCase().trim()
  // If input is already a valid abbreviation, return it
  if (Object.values(countryAbbreviations).includes(upperName)) {
    return upperName
  }
  // Try to convert from full name
  const abbrev = countryAbbreviations[upperName]
  if (abbrev) {
    return abbrev
  }
  // If not found, try to match partial names (for multi-word countries)
  const partialMatch = Object.entries(countryAbbreviations).find(([fullName]) =>
    upperName.split(" ").every((word) => fullName.includes(word)),
  )
  if (partialMatch) {
    return partialMatch[1]
  }
  // If still not found, return the original input
  return name.trim()
}

export const countryAbbrevToName = (abbrev: string): string => {
  const upperAbbrev = abbrev.toUpperCase().trim()
  return Object.entries(countryAbbreviations).find(([_, abb]) => abb === upperAbbrev)?.[0] || upperAbbrev
}
